<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <StoryBreadcrumb />
    </template>

    <template #main>
      <StoryMain />
    </template>

    <template #asideSecondary>
      <StoryAsideSecondary />
    </template>

    <template #breadcrumbFooter>
      <StoryBreadcrumb />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import StoryBreadcrumb from './Breadcrumb.vue'
import StoryMain from './Main.vue'
import StoryAsideSecondary from './AsideSecondary.vue'

export default defineComponent({
  name: 'StoryApp',

  components: {
    StoryBreadcrumb,
    StoryMain,
    StoryAsideSecondary,
  },
})
</script>

